import script from "./form-card-item-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./form-card-item-icon.vue?vue&type=script&setup=true&lang=js"

import "./form-card-item-icon.vue?vue&type=style&index=0&id=1c8bec14&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8bec14"]])

export default __exports__